<template>
  <Head title="Forgot Password" />

  <div class="flex flex-col gap-y-5">
    <div class="text-gray-100">
      <h3 class="text-3xl font-semibold pb-1">Password Reset</h3>
      <p>Forgot your password? Enter your email address and we’ll email a password reset link.</p>
    </div>

    <BreezeStatusMessage v-if="status">{{ status }}</BreezeStatusMessage>

    <BreezeValidationErrors />

    <form
      @submit.prevent="submit"
      class="flex flex-col gap-y-5"
    >
      <div>
        <BreezeLabel
          for="email"
          value="Email"
          class="sr-only"
        />
        <BreezeInput
          id="email"
          type="email"
          v-model="form.email"
          required
          autofocus
          autocomplete="username"
          placeholder="Email address"
        />
      </div>

      <div class="flex items-center justify-start">
        <BreezeButton
          class="w-full"
          :class="{ 'opacity-25': form.processing }"
          :disabled="form.processing"
        >
          Reset
        </BreezeButton>
      </div>

      <div class="flex flex-row justify-between mt-3">
        <Link
          :href="route('login')"
          class="underline font-semibold text-gray-100 hover:text-gray-100"
        >
          Back to Login
        </Link>
      </div>
    </form>
  </div>
</template>

<script>
import BreezeButton from '@/Components/Auth/Button.vue'
import BreezeGuestLayout from '@/Layouts/Guest.vue'
import BreezeInput from '@/Components/Auth/Input.vue'
import BreezeLabel from '@/Components/Auth/Label.vue'
import BreezeValidationErrors from '@/Components/Auth/ValidationErrors.vue'
import BreezeStatusMessage from '@/Components/Auth/StatusMessage.vue'
import { Head, Link } from '@inertiajs/vue3'

export default {
  layout: BreezeGuestLayout,

  components: {
    BreezeButton,
    BreezeInput,
    BreezeLabel,
    BreezeValidationErrors,
    BreezeStatusMessage,
    Head,
    Link
  },

  props: {
    status: String
  },

  data() {
    return {
      form: this.$inertia.form({
        email: ''
      })
    }
  },

  methods: {
    submit() {
      this.form.post(this.route('password.email'))
    }
  }
}
</script>
